import { useAlertContext } from "../contexts/AlertContext";

export const useAlert = () => {
  const { setAlert } = useAlertContext();

  const showSuccess = (message: string) => {
    setAlert({
      open: true,
      message,
      severity: "success",
    });
  };

  const showError = (message: string) => {
    setAlert({
      open: true,
      message,
      severity: "error",
    });
  };

  const showInfo = (message: string) => {
    setAlert({
      open: true,
      message,
      severity: "info",
    });
  };

  const showWarning = (message: string) => {
    setAlert({
      open: true,
      message,
      severity: "warning",
    });
  };

  return {
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
};
